/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".studyIconsContainer[_ngcontent-%COMP%]{min-width:10rem}.studyIconsContainer[_ngcontent-%COMP%]   .studyIcon[_ngcontent-%COMP%]{width:1rem;height:1rem;margin:.1rem;cursor:pointer}"];
export { styles as styles };

